import I18n from 'I18n';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoResultsMessage = ({
  children,
  width = '200px'
}) => /*#__PURE__*/_jsxs(View, {
  textAlign: "center",
  children: [/*#__PURE__*/_jsx(Illustration, {
    name: "empty-state-charts",
    alt: I18n.text('noResultsMessage'),
    inlineSize: width,
    marginBlockEnd: "200"
  }), /*#__PURE__*/_jsx("div", {
    style: {
      maxWidth: '500px'
    },
    children: children
  })]
});
export default NoResultsMessage;